const Menu = [
  {
    text: "Principal",
    icon: "mdi-home",
    to: "/principal",
    client: true,
    readonly: true
  },
  {
    text: "Usuarios",
    icon: "mdi-account-multiple",
    to: "/usuarios"
  },
  { header: "Configuración" },
  // {
  //   text: "PC's Autorizados",
  //   icon: "mdi-laptop",
  //   to: "/pc-autorizados"
  // },
  // {
  //   text: "Cajas de Sensores",
  //   icon: "mdi-cube-outline",
  //   to: "/cajas-sensores"
  // },
  {
    text: "Parques Eólicos",
    icon: "mdi-map-marker",
    to: "/parques",
    client: true,
    readonly: true
  },
  {
    text: "Clientes",
    icon: "mdi-view-list",
    to: "/clientes",
    readonly: true
  },
  {
    text: "Adjudicaciones",
    icon: "mdi-format-list-bulleted",
    to: "/adjudicaciones"
  },
  {
    text: "Ordenes de Trabajo",
    icon: "mdi-file-document-edit",
    to: "/ordenes-trabajo"
  },
  {
    text: "Revisión de Intervenciones",
    icon: "mdi-magnify",
    to: "/revision-intervenciones",
    client: true,
    readonly: true
  },
  {
    text: "Generación de Informes",
    icon: "mdi-file",
    to: "/informes",
    client: true,
    readonly: true
  },
  {
    text: "Otros Informes",
    icon: "mdi-file",
    group: 'true',
    children: [
      {
        text: "Bloques de trabajo",
        icon: "mdi-file",
        to: "/otros-informes/work-blocks"
      },
      {
        text: "AG Intervenciones",
        icon: "mdi-file",
        to: "/otros-informes/ag-work-interventions"
      },
      {
        text: "Materiales",
        icon: "mdi-file",
        to: "/otros-informes/used-materials"
      },
      {
        text: "Residuos",
        icon: "mdi-file",
        to: "/otros-informes/waste-parts"
      },
    ]
  },
];

export default Menu;
